/// <reference path="../../typings/browser.d.ts" />
/// <reference path="../../customtypings/window.d.ts" />

/**
 * MultiBlock service
 */

namespace Application.Services {
    'use strict';

    import IHalList = Models.IHalList;
    import HalConverter = Models.HalConverter;
    import MultiBlock = Application.Models.MultiBlock;
    import IMultiBlock = Application.Models.IMultiBlock;
    import IHalElement = Application.Models.IHalElement;
    
    
    /**
     * NetworkService
     */
    export class MultiBlockService {
        public static $name: string = "multiBlockService";
        public static $inject: string[] = ['backendService'];

        private backendService: BackendService;
        private backendBaseUrl: string = window.backendUrl;
        private servicePath: string = '';
        private backendUrl: string = this.backendBaseUrl + this.servicePath + 'multiBlocks';
        private createUrl: string = this.backendUrl + '/create';
        private isInMultiUrl: string = this.backendUrl + '/isInMultiBlock?blockId=';
        

        constructor(backendService: BackendService) {
            this.backendService = backendService;
        }


        public getAllMultiBlocks(): ng.IPromise<MultiBlock[]> {
            return this.backendService.get(this.backendUrl).then(
                (result: ng.IHttpPromiseCallbackArg<IHalList<IMultiBlock>>) => {
                    return HalConverter.convertList(result.data, MultiBlock.Empty);
                });
        }

        public createMultiBlock(newMultiBlock: Models.INewMultiBlock): ng.IPromise<MultiBlock> {
            return this.backendService.post(this.createUrl, newMultiBlock)
                .then((result: ng.IHttpPromiseCallbackArg<IHalElement<IMultiBlock>>) => {
                    return HalConverter.convertElement(result.data, MultiBlock.Empty);
            });
        }


        public removeMultiBlock(multiBlock: Models.IMultiBlock): ng.IPromise<boolean> {
            return this.backendService.delete(multiBlock.href);
        }

        public isInMultiBlock(blockId: number): ng.IPromise<boolean> {
            return this.backendService.get(this.isInMultiUrl + blockId).then(
                (result: ng.IHttpPromiseCallbackArg<boolean>) => {
                    return result.data;
                }
            );
        }

        public isMultiBlockConnected(multiBlock: MultiBlock): boolean {
            return multiBlock.destBlockConnection.connected || multiBlock.origBlockConnection.connected;
        }
    }
}